import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient, HttpHeaders} from '@angular/common/http';

const contentHeader = new HttpHeaders(
  {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0'
  });

@Injectable()
export class ConfigService {

  apiBaseUrl: string;
  apiBaseUrlEmail: string;
  private httpClient: HttpClient;
  private settings: any;
  s3EndPoint: string;
  countries: any;
 
  constructor(private readonly httpHandler: HttpBackend) {
    this.httpClient = new HttpClient(httpHandler);
  }

  async loadConfig() {
    const data = await this.httpClient.get<any>('./assets/data/config.json', {headers: contentHeader})
      .toPromise();
    this.apiBaseUrl = data.apiBaseUrlLocal_10;
    this.apiBaseUrlEmail = data.apiBaseUrlEmail;
    this.s3EndPoint = data.s3EndPoint;
  }

  async loadCountry() {
    this.countries = await this.httpClient.get<any>('assets/data/countries.json', {headers: contentHeader})
      .toPromise();
  }
}
